import { Button } from "@base/ui/Button/Button";
import { Dialog } from "@base/ui/Dialog";
import { useTranslation } from "react-i18next";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const UnscribeCompleteDialog = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Dialog.Content>
        <div className="flex flex-col gap-4 p-4 pt-6">
          <Dialog.Title>{t("unsubscribeComplete")}</Dialog.Title>

          <Button type="button" className="w-full" onClick={onClose}>
            {t("ok")}
          </Button>
        </div>
      </Dialog.Content>
    </Dialog>
  );
};

export default UnscribeCompleteDialog;
